import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const ExamAttemptViewLazy = React.lazy(
	() => import(/* webpackChunkName: 'ExamAttemptView' */ './components')
);

export default () => {
	return {
		path: 'examgrading-setup/exam-setup/:campusId/:examId/view-submission/:configId/:examAttemptId',
		element: (
			<AsyncLoading
				component={
					<ExamAttemptViewLazy
						permission="CanViewExamGradingSetup"
						featureFlag="FeatureFlag:OnlineExams"
					/>
				}
			/>
		),
	};
};
